module.exports = __webpack_public_path__ + "overshootInTop.gif";